export const formatEmailAddress = (email) => (email || '').toLowerCase().trim()

// https://ui.dev/validate-email-address-javascript/
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
export const validateEmail = (str) => emailRegex.test(str)
